<template>
  <svg
    :class="['animate-spin shrink-0', sizeClasses[size]]"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :aria-hidden="label ? undefined : 'true'"
    :role="label ? 'status' : undefined"
    :aria-label="label || undefined"
  >
    <!-- Track: full circle at 30% opacity -->
    <circle
      cx="10"
      cy="10"
      r="9"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      opacity="0.3"
    />
    <!-- Indicator: quarter arc (top → right, clockwise) -->
    <path
      d="M10 1A9 9 0 0 1 19 10"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'AppSpinner',

  props: {
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md', 'lg'].includes(v),
    },
    // Set a label when the spinner is the sole loading indicator (standalone use).
    // Omit when inside a button or other labelled container — aria-hidden is used instead.
    label: { type: String, default: '' },
  },

  computed: {
    sizeClasses() {
      return { sm: 'size-4', md: 'size-5', lg: 'size-6' };
    },
  },
};
</script>
